import React, { useState } from 'react';
import './ChartConfigurationType.scss';
import { FlightTabs, getIcon } from '@flybits/design-system';
import { ReactComponent as RecommendedIcon } from 'assets/icons/recommended.svg';
import { CHART_CONFIGURATION_TYPES } from 'pages/AnalyticsV2/CustomAnalytics/CreateOrEditChart/constants';
const MAIN_CLASS = 'chart-config-selector';
const CLASSES = {
  TABS: `${MAIN_CLASS}__tabs`,
  TAB_LABEL: `${MAIN_CLASS}__tab-label`,
};
interface ChartConfigurationTypeProps {
  currrentSelection?: CHART_CONFIGURATION_TYPES;
  onSelect?: (s: CHART_CONFIGURATION_TYPES) => void;
}
export default function ChartConfigurationType({ currrentSelection, onSelect }: ChartConfigurationTypeProps) {
  const [selectedTab, setSelectedTab] = useState<string>(currrentSelection || CHART_CONFIGURATION_TYPES.RECOMMENDED);
  const selectTab = (selected: CHART_CONFIGURATION_TYPES) => {
    setSelectedTab(selected);
    onSelect && onSelect(selected);
  };
  return (
    <div className={MAIN_CLASS}>
      <FlightTabs
        labels={[
          {
            key: CHART_CONFIGURATION_TYPES.RECOMMENDED,
            name: (
              <span className={CLASSES.TAB_LABEL}>
                <RecommendedIcon aria-hidden />
                Pre-built widgets
              </span>
            ),
          },
          {
            key: CHART_CONFIGURATION_TYPES.DO_IT_YOURSELF,
            name: (
              <span className={CLASSES.TAB_LABEL}>
                {getIcon('build', {})}
                Do it yourself
              </span>
            ),
          },
        ]}
        className={CLASSES.TABS}
        selectedTab={selectedTab}
        onSelect={(e: { key: CHART_CONFIGURATION_TYPES }) => {
          selectTab(e.key);
        }}
      />
    </div>
  );
}
